const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

export async function fetchUsers({ page = 1, limit = 5, search = '', sortBy = 'createdAt', order = 'desc' } = {}) {
  const params = new URLSearchParams({ page, limit, search, sortBy, order });
  const res = await fetch(`${API_URL}/users?${params.toString()}`);
  if (!res.ok) throw new Error('Failed to fetch users.');
  return res.json();
}

export async function saveUser(user) {
  const res = await fetch(`${API_URL}/users`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(user),
  });
  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new Error(data.message || 'Failed to save user.');
  }
  return res.json();
}

export async function deleteUser(id) {
  const res = await fetch(`${API_URL}/users/${id}`, { method: 'DELETE' });
  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new Error(data.message || 'Failed to delete user.');
  }
  return res.json();
}
